import { render, staticRenderFns } from "./crm-coupon.vue?vue&type=template&id=5b5389a0&scoped=true"
import script from "./crm-coupon.vue?vue&type=script&lang=js"
export * from "./crm-coupon.vue?vue&type=script&lang=js"
import style0 from "./crm-coupon.vue?vue&type=style&index=0&id=5b5389a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5389a0",
  null
  
)

export default component.exports